import { IRestoreLaborRequest, IUpdateLaborRequest } from 'types';

export enum LaborReview {
  GET_LABOR_REQUEST = '@laborreview/GET_LABOR_REQUEST',
  GET_LABOR_SUCCESS = '@laborreview/GET_LABOR_SUCCESS',
  GET_LABOR_FAIL = '@laborreview/GET_LABOR_FAIL',

  GET_POS_JOB_TITLES_REQUEST = '@laborreview/GET_POS_JOB_TITLES_REQUEST',
  GET_POS_JOB_TITLES_SUCCESS = '@laborreview/GET_POS_JOB_TITLES_SUCCESS',
  GET_POS_JOB_TITLES_FAIL = '@laborreview/GET_POS_JOB_TITLES_FAIL',

  UPDATE_LABOR_REQUEST = '@laborreview/UPDATE_LABOR_REQUEST',
  UPDATE_LABOR_SUCCESS = '@laborreview/UPDATE_LABOR_SUCCESS',
  UPDATE_LABOR_FAIL = '@laborreview/UPDATE_LABOR_FAIL',

  RESTORE_LABOR_REQUEST = '@laborreview/RESTORE_LABOR_REQUEST',
  RESTORE_LABOR_SUCCESS = '@laborreview/RESTORE_LABOR_SUCCESS',
  RESTORE_LABOR_FAIL = '@laborreview/RESTORE_LABOR_FAIL',
}

export interface IGetPosJobTitlesPayload {
  siteId: string;
}

export interface IGetLaborPayload {
  siteId: string;
  date: string;
}

export interface IUpdateLaborPayload extends IGetLaborPayload {
  locationId: string;
  employeeId: string;
  body: IUpdateLaborRequest;
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

export interface IRestoreLaborPayload extends IGetLaborPayload {
  locationId: string;
  employeeId: string;
  body: IRestoreLaborRequest;
  onSuccess?: () => void;
  onError?: (error: any) => void;
}
